var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('step-questions-list', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.questions,
      callback: function ($$v) {
        _vm.$set(_vm.form, "questions", $$v);
      },
      expression: "form.questions"
    }
  }, 'step-questions-list', {
    _recruitment: _vm.value._recruitment
  }, false)), _c('div', {
    staticClass: "v-btn-group flex-wrap"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('prev');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("이전으로")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("임시저장")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.save(_vm.COMPLETED.value);
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v("저장 후 다음으로")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }